import { render } from "./NameSearchResult.vue?vue&type=template&id=eff8b17e"
import script from "./NameSearchResult.vue?vue&type=script&lang=js"
export * from "./NameSearchResult.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__